import React from "react";

const Footer = () => (
  <footer className="border-t">
    <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-3 gap-8">
      {/* Logo + tagline */}
      <div>
        <img
          src="/armadapos-logo.png"
          alt="Armada POS"
          className="h-8 w-auto mb-3"
        />
        <p className="text-slate-600 text-sm">
          POS your staff love, insights owners trust.
        </p>
      </div>

      {/* Product */}
      <div className="text-sm">
        <h4 className="font-semibold mb-2">Product</h4>
        <ul className="space-y-1 text-slate-600">
          <li><a href="#features" className="hover:text-blue-700">Features</a></li>
          <li><a href="#comparison" className="hover:text-blue-700">Why Armada</a></li>
          <li><a href="#industries" className="hover:text-blue-700">Industries</a></li>
          <li><a href="#integrations" className="hover:text-blue-700">Integrations</a></li>
          <li><a href="#hardware" className="hover:text-blue-700">Hardware</a></li>
        </ul>
      </div>

      {/* Get Started */}
      <div className="text-sm">
        <h4 className="font-semibold mb-2">Get Started</h4>
        <ul className="space-y-1 text-slate-600">
          <li><a href="#signup" className="hover:text-blue-700">Start Free Trial</a></li>
          <li><a href="#faq" className="hover:text-blue-700">FAQ</a></li>
        </ul>
      </div>
    </div>

    {/* Bottom line */}
    <div className="max-w-6xl mx-auto px-4 py-6 text-center text-xs text-slate-500">
      © {new Date().getFullYear()} Armada POS. All rights reserved.
    </div>
  </footer>
);

export default Footer;
